import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

export default function NavbarQuiz({ onSearch }) {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);
    onSearch({ searchTerm: newSearchTerm });
  };

  return (
    <div className="navbarQuiz">
      <div className="search-bar">
        <FaSearch className="search-icon" />
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>
    </div>
  );
}